import IconButton from '@/components/IconButton/IconButton';

import { copyToClipboard } from '../lib/format';

const CopyIcon = (
  <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-4 w-4">
    <path d="M7 3.5A1.5 1.5 0 0 1 8.5 2h6A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 7 12.5v-9z" />
    <path d="M4 6.5A1.5 1.5 0 0 1 5.5 5H6v8a2.5 2.5 0 0 0 2.5 2.5H13v.5a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 4 16V6.5z" />
  </svg>
);

interface ReadOnlyRowProps {
  label: string;
  value: string;
  mono?: boolean;
  copyLabel?: string;
}

/**
 * A read-only label/value row used inside home-automation settings. When
 * `copyLabel` is provided, a copy-to-clipboard icon button is shown.
 */
export default function ReadOnlyRow({ label, value, mono, copyLabel }: ReadOnlyRowProps) {
  return (
    <div className="flex items-start gap-3 border-b border-(--border-subtle) py-2 last:border-b-0">
      <span className="w-28 shrink-0 text-xs font-medium text-(--text-secondary)">{label}</span>
      <span className={`min-w-0 flex-1 text-sm break-all text-(--text-primary) ${mono ? 'font-mono' : ''}`}>{value}</span>
      {copyLabel && (
        <IconButton
          variant="ghost"
          size="sm"
          aria-label={`Copy ${copyLabel}`}
          icon={CopyIcon}
          onClick={() => void copyToClipboard(value, copyLabel)}
        />
      )}
    </div>
  );
}
